import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  wrapper: {
    flex: '1',
    position: 'relative',
    marginRight: '-1rem',
  },

  content: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflowX: 'auto',
    paddingRight: '1rem',
  },
})

export default useStyles
